module.exports = __webpack_public_path__ + "img/covertex-img.3c61e1fd.jpg";